(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-conocemas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const openMenuBtn = document.getElementById('open-menu');
    const closeMenuBtn = document.getElementById('close-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    const headerBanner = document.querySelector('.hero-ingredientes-banner .header-banner');

    if(openMenuBtn) {
      openMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'flex';
        document.body.classList.add('menu-open');
      });
    }

    if(closeMenuBtn) {
      closeMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'none';
        document.body.classList.remove('menu-open');
      });
    }

    function handleHeaderScroll() {
      if (window.scrollY > 10) {
        if(headerBanner) headerBanner.classList.add('scrolled');
      } else {
        if(headerBanner) headerBanner.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', handleHeaderScroll);
    handleHeaderScroll();

    function toggleDrawer(triggerId, drawerId, closeBtnId) {
      const trigger = document.getElementById(triggerId);
      const drawer = document.getElementById(drawerId);
      const closeBtn = document.getElementById(closeBtnId);
      if(!trigger || !drawer) return;

      const open = () => { drawer.classList.add('active'); document.body.style.overflow = 'hidden'; };
      const close = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; };

      trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
      if(closeBtn) closeBtn.addEventListener('click', close);
      drawer.addEventListener('click', (e) => { if(e.target === drawer) close(); });
    }

    toggleDrawer('login-drawer-trigger', 'taw-login-drawer', 'close-login-drawer');
    toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

    const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
    const cartContainer = document.getElementById('cart-drawer-items');
    const countEl = document.getElementById('drawer-cart-count');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const bubble = document.getElementById('cart-count-number');

    if(cartTrigger) cartTrigger.addEventListener('click', fetchCart);

    function fetchCart() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => renderCart(cart));
    }

    function renderCart(cart) {
      if(countEl) countEl.innerText = cart.item_count;
      if(bubble) bubble.innerText = cart.item_count;
      if(subtotalEl) subtotalEl.innerText = '$' + (cart.total_price / 100).toFixed(0);
      cartContainer.innerHTML = '';
      if(cart.items.length === 0) {
        cartContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
        return;
      }
      cart.items.forEach(item => {
        cartContainer.innerHTML += `
          <div class="drawer-item">
            <div class="drawer-item-image"><a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a></div>
            <div class="drawer-item-details">
              <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
              <div class="qty-selector">
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
                <span>${item.quantity}</span>
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>`;
      });
    }

    window.changeQty = (key, qty) => {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      }).then(res => res.json()).then(cart => renderCart(cart));
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // === MENU & HEADER LOGIC ===
    const openMenuBtn = document.getElementById('open-menu');
    const closeMenuBtn = document.getElementById('close-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    const headerBanner = document.querySelector('.hero-ingredientes-banner .header-banner');

    if(openMenuBtn) {
      openMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'flex';
        document.body.classList.add('menu-open');
      });
    }

    if(closeMenuBtn) {
      closeMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'none';
        document.body.classList.remove('menu-open');
      });
    }

    function handleHeaderScroll() {
      if (window.scrollY > 10) {
        if(headerBanner) headerBanner.classList.add('scrolled');
      } else {
        if(headerBanner) headerBanner.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', handleHeaderScroll);
    handleHeaderScroll();

    // === GESTIÓN DE DRAWERS ===
    function toggleDrawer(triggerId, drawerId, closeBtnId) {
      const trigger = document.getElementById(triggerId);
      const drawer = document.getElementById(drawerId);
      const closeBtn = document.getElementById(closeBtnId);
      
      if(!trigger || !drawer) return;

      const openDrawer = () => {
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
      };
      const closeDrawer = () => {
        drawer.classList.remove('active');
        document.body.style.overflow = '';
      };

      trigger.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
      if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', (e) => { if (e.target === drawer) closeDrawer(); });
    }

    toggleDrawer('login-drawer-trigger', 'taw-login-drawer', 'close-login-drawer');
    toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

    // === LÓGICA DE CARRITO (AJAX) ===
    const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
    const cartItemsContainer = document.getElementById('cart-drawer-items');
    const cartCountEl = document.getElementById('drawer-cart-count');
    const cartSubtotalEl = document.getElementById('cart-drawer-subtotal');
    const cartBubbleNumber = document.getElementById('cart-count-number');

    if(cartTrigger) {
      cartTrigger.addEventListener('click', () => fetchCart());
    }

    function formatMoney(cents) { return '$' + (cents / 100).toFixed(0); }

    function fetchCart() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => { renderCart(cart); updateCartCount(cart.item_count); })
        .catch(err => console.error(err));
    }

    function renderCart(cart) {
      if(cartCountEl) cartCountEl.innerText = cart.item_count;
      if(cartSubtotalEl) cartSubtotalEl.innerText = formatMoney(cart.total_price);
      cartItemsContainer.innerHTML = '';

      if (cart.items.length === 0) {
        cartItemsContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
        return;
      }

      cart.items.forEach(item => {
        cartItemsContainer.innerHTML += `
          <div class="drawer-item">
            <div class="drawer-item-image">
               <a href="${item.url}"><img src="${item.image || ''}" alt="${item.title}"></a>
            </div>
            <div class="drawer-item-details">
              <div class="drawer-item-text">
                <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
              </div>
              <div class="qty-selector">
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>
        `;
      });
    }

    window.changeQty = function(key, newQty) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(res => res.json())
      .then(cart => { renderCart(cart); updateCartCount(cart.item_count); });
    };

    function updateCartCount(count) {
      if(cartBubbleNumber) cartBubbleNumber.innerText = count;
      if(cartCountEl) cartCountEl.innerText = count;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["conoce-mas"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
  });
  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
  });

  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
    document.body.classList.add('menu-open'); // 🔥 activa la clase
  });

  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
    document.body.classList.remove('menu-open'); // 🔥 remueve la clase
  });


  function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');

  if (cartBubble) {
    // Si no existe el icono personalizado, lo agregamos
    if (!cartBubble.querySelector('#icon-cart')) {
      // Elimina el SVG original (si lo hubiera)
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();

      // Inserta el icono personalizado (solo beige)
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';

      cartBubble.prepend(img);
    }
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  // Detectar cambios en el DOM del header (Shopify lo recarga dinámicamente)
  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.getElementById('open-menu');
  const closeBtn = document.getElementById('close-menu');
  const menu = document.getElementById('mobile-menu');
  
  const header = document.querySelector('.header-banner');
  const logoImg = document.getElementById('header-logo-img');

  if(openBtn) openBtn.addEventListener('click', () => { menu.style.display = 'flex'; document.body.style.overflow = 'hidden'; });
  if(closeBtn) closeBtn.addEventListener('click', () => { menu.style.display = 'none'; document.body.style.overflow = ''; });

  // 1. SCROLL LOGIC
  function handleScroll() {
    if (window.scrollY > 10) {
      // Estado Scrolled (Fondo Original, Logo Beige, Texto Claro)
      header.classList.add('scrolled');
      if(logoImg && logoImg.dataset.srcScrolled) {
        logoImg.src = logoImg.dataset.srcScrolled;
      }
    } else {
      // Estado Normal (Transparente, Logo Original)
      header.classList.remove('scrolled');
      if(logoImg && logoImg.dataset.srcDefault) {
        logoImg.src = logoImg.dataset.srcDefault;
      }
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();

  function toggleDrawer(triggerId, drawerId, closeBtnId) {
    const trigger = document.getElementById(triggerId);
    const drawer = document.getElementById(drawerId);
    const closeBtn = document.getElementById(closeBtnId);
    if(!trigger || !drawer) return;

    const open = () => { drawer.classList.add('active'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; };

    trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
    if(closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', (e) => { if(e.target === drawer) close(); });
    return { open, close };
  }

  toggleDrawer('login-drawer-trigger', 'taw-login-drawer', 'close-login-drawer');
  const cartDrawer = toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

  const cartContainer = document.getElementById('cart-drawer-items');
  const countEl = document.getElementById('drawer-cart-count');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const bubble = document.getElementById('cart-count-number');
  const cartTrigger = document.getElementById('cart-icon-bubble-trigger');

  if(cartTrigger) cartTrigger.addEventListener('click', fetchCart);

  function fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => renderCart(cart));
  }

  function renderCart(cart) {
    if(countEl) countEl.innerText = cart.item_count;
    if(bubble) bubble.innerText = cart.item_count;
    if(subtotalEl) subtotalEl.innerText = '$' + (cart.total_price / 100).toFixed(0);
    
    cartContainer.innerHTML = '';
    if(cart.items.length === 0) {
      cartContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
      return;
    }

    cart.items.forEach(item => {
      cartContainer.innerHTML += `
        <div class="drawer-item">
          <div class="drawer-item-image"><a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a></div>
          <div class="drawer-item-details">
            <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
            <div class="qty-selector">
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
              <span>${item.quantity}</span>
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>`;
    });
  }

  window.changeQty = (key, qty) => {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(res => res.json()).then(cart => renderCart(cart));
  };

  // AJUSTE: SELECTOR DE CANTIDAD EN LA PDP
  const qtyWrapper = document.querySelector('.quantity-selector');
  const qtyInput = qtyWrapper ? qtyWrapper.querySelector('.qty-input') : null;

  if (qtyWrapper && qtyInput) {
    const minusBtn = qtyWrapper.querySelector('.qty-minus');
    const plusBtn = qtyWrapper.querySelector('.qty-plus');

    minusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      val = Math.max(1, val - 1);
      qtyInput.value = val;
    });

    plusBtn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      val = val + 1;
      qtyInput.value = val;
    });

    qtyInput.addEventListener('change', () => {
      let val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      qtyInput.value = val;
    });
  }

  const productForm = document.querySelector('.product-form');
  if(productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = productForm.querySelector('.add-to-cart-btn');
      const originalText = btn.innerText;
      btn.innerText = 'Agregando...';
      
      const formData = new FormData(productForm);
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(() => {
          fetchCart();
          cartDrawer.open(); 
          btn.innerText = originalText;
          // AJUSTE: reiniciar el selector de cantidad a 1 después de agregar al carrito
          if (qtyInput) qtyInput.value = 1;
        })
        .catch(err => { console.error(err); btn.innerText = originalText; });
    });
  }

  const mainImg = document.getElementById('main-product-image-{{ section.id }}');
  const dots = document.querySelectorAll('.gallery-dot');
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      if(mainImg) {
        mainImg.classList.add('fade');
        setTimeout(() => { mainImg.src = dot.dataset.imageSrc; mainImg.classList.remove('fade'); }, 200);
      }
      dots.forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
    });
  });

  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', (e) => {
      e.preventDefault();
      const item = header.parentElement;
      const content = item.querySelector('.accordion-content');
      item.classList.toggle('active');
      if(item.classList.contains('active')) content.style.maxHeight = content.scrollHeight + 'px';
      else content.style.maxHeight = '0px';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home-taw"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // 1. MENU MOBILE
    const openMenuBtn = document.getElementById('open-menu');
    const closeMenuBtn = document.getElementById('close-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    const headerBanner = document.querySelector('.hero-ingredientes-banner .header-banner');

    if(openMenuBtn) {
      openMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'flex';
        document.body.classList.add('menu-open');
      });
    }

    if(closeMenuBtn) {
      closeMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'none';
        document.body.classList.remove('menu-open');
      });
    }

    // 2. SCROLL
    function handleHeaderScroll() {
      if (window.scrollY > 10) headerBanner.classList.add('scrolled');
      else headerBanner.classList.remove('scrolled');
    }
    window.addEventListener('scroll', handleHeaderScroll);
    handleHeaderScroll();

    // 3. GESTIÓN DRAWERS
    function toggleDrawer(triggerId, drawerId, closeBtnId) {
      const trigger = document.getElementById(triggerId);
      const drawer = document.getElementById(drawerId);
      const closeBtn = document.getElementById(closeBtnId);
      
      if(!trigger || !drawer) return;

      const openDrawer = () => {
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
      };
      const closeDrawer = () => {
        drawer.classList.remove('active');
        document.body.style.overflow = '';
      };

      trigger.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
      if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', (e) => { if (e.target === drawer) closeDrawer(); });
    }

    toggleDrawer('login-drawer-trigger', 'taw-login-drawer', 'close-login-drawer');
    toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

    // 4. CART LOGIC
    const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
    const cartItemsContainer = document.getElementById('cart-drawer-items');
    const cartCountEl = document.getElementById('drawer-cart-count');
    const cartSubtotalEl = document.getElementById('cart-drawer-subtotal');
    const cartBubbleNumber = document.getElementById('cart-count-number');

    if(cartTrigger) cartTrigger.addEventListener('click', () => fetchCart());

    function formatMoney(cents) { return '$' + (cents / 100).toFixed(0); }

    function fetchCart() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => { renderCart(cart); updateCartCount(cart.item_count); })
        .catch(err => console.error(err));
    }

    function renderCart(cart) {
      if(cartCountEl) cartCountEl.innerText = cart.item_count;
      if(cartSubtotalEl) cartSubtotalEl.innerText = formatMoney(cart.total_price);
      cartItemsContainer.innerHTML = '';

      if (cart.items.length === 0) {
        cartItemsContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
        return;
      }

      cart.items.forEach(item => {
        cartItemsContainer.innerHTML += `
          <div class="drawer-item">
            <div class="drawer-item-image">
               <a href="${item.url}"><img src="${item.image || ''}" alt="${item.title}"></a>
            </div>
            <div class="drawer-item-details">
              <div class="drawer-item-text">
                <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
              </div>
              <div class="qty-selector">
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>
        `;
      });
    }

    window.changeQty = function(key, newQty) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(res => res.json())
      .then(cart => { renderCart(cart); updateCartCount(cart.item_count); });
    };

    function updateCartCount(count) {
      if(cartBubbleNumber) cartBubbleNumber.innerText = count;
      if(cartCountEl) cartCountEl.innerText = count;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ingredientes-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const openMenuBtn = document.getElementById('open-menu');
    const closeMenuBtn = document.getElementById('close-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    const headerBanner = document.querySelector('.hero-ingredientes-banner .header-banner');

    if(openMenuBtn) {
      openMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'flex';
        document.body.classList.add('menu-open');
      });
    }

    if(closeMenuBtn) {
      closeMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'none';
        document.body.classList.remove('menu-open');
      });
    }

    function handleHeaderScroll() {
      if (window.scrollY > 10) {
        if(headerBanner) headerBanner.classList.add('scrolled');
      } else {
        if(headerBanner) headerBanner.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', handleHeaderScroll);
    handleHeaderScroll();

    function toggleDrawer(triggerId, drawerId, closeBtnId) {
      const trigger = document.getElementById(triggerId);
      const drawer = document.getElementById(drawerId);
      const closeBtn = document.getElementById(closeBtnId);
      if(!trigger || !drawer) return;

      const open = () => { drawer.classList.add('active'); document.body.style.overflow = 'hidden'; };
      const close = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; };

      trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
      if(closeBtn) closeBtn.addEventListener('click', close);
      drawer.addEventListener('click', (e) => { if(e.target === drawer) close(); });
    }

    toggleDrawer('login-drawer-trigger', 'taw-login-drawer', 'close-login-drawer');
    toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

    const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
    const cartContainer = document.getElementById('cart-drawer-items');
    const countEl = document.getElementById('drawer-cart-count');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const bubble = document.getElementById('cart-count-number');

    if(cartTrigger) cartTrigger.addEventListener('click', fetchCart);

    function fetchCart() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => renderCart(cart));
    }

    function renderCart(cart) {
      if(countEl) countEl.innerText = cart.item_count;
      if(bubble) bubble.innerText = cart.item_count;
      if(subtotalEl) subtotalEl.innerText = '$' + (cart.total_price / 100).toFixed(0);
      cartContainer.innerHTML = '';
      if(cart.items.length === 0) {
        cartContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
        return;
      }
      cart.items.forEach(item => {
        cartContainer.innerHTML += `
          <div class="drawer-item">
            <div class="drawer-item-image"><a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a></div>
            <div class="drawer-item-details">
              <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
              <div class="qty-selector">
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
                <span>${item.quantity}</span>
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>`;
      });
    }

    window.changeQty = (key, qty) => {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      }).then(res => res.json()).then(cart => renderCart(cart));
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ingredientes-video"] && !Shopify.designMode) return;
  try {
    
document.getElementById('open-menu').addEventListener('click', function () {
  document.getElementById('mobile-menu').style.display = 'flex';
  document.body.classList.add('menu-open');
});

document.getElementById('close-menu').addEventListener('click', function () {
  document.getElementById('mobile-menu').style.display = 'none';
  document.body.classList.remove('menu-open');
});

function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');
  if (cartBubble) {
    if (!cartBubble.querySelector('#icon-cart')) {
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';
      cartBubble.prepend(img);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, { childList: true, subtree: true });
});


// Seleccionamos el header
const headerTAW = document.querySelector('.hero-taw .header-taw');

// Función que activa/desactiva la clase según scroll
function handleHeaderScroll() {
  if (window.scrollY > 50) { // Si el scroll pasa 50px
    headerTAW.classList.add('scrolled');
  } else {
    headerTAW.classList.remove('scrolled');
  }
}

// Escuchamos el scroll
window.addEventListener('scroll', handleHeaderScroll);

// Ejecutamos al cargar por si ya hay scroll
document.addEventListener('DOMContentLoaded', handleHeaderScroll);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  // ... (El JAVASCRIPT no necesita cambios, es el mismo de antes) ...
  class HotspotSection {
    constructor(container) {
      this.container = container;
      if (!this.container) return;
      this.triggers = this.container.querySelectorAll('[data-hotspot-trigger]');
      this.contents = this.container.querySelectorAll('[data-hotspot-content]');
      this.init();
    }
    init() {
      if (this.triggers.length === 0) return;
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => this.onTriggerClick(trigger));
      });
    }
    onTriggerClick(clickedTrigger) {
      const targetId = clickedTrigger.dataset.hotspotTrigger;
      this.triggers.forEach(t => t.classList.remove('is-active'));
      this.contents.forEach(c => c.classList.remove('is-active'));
      clickedTrigger.classList.add('is-active');
      const targetContent = this.container.querySelector(`[data-hotspot-content="${targetId}"]`);
      if (targetContent) {
        targetContent.classList.add('is-active');
      }
    }
  }
  function initHotspotSections() {
    document.querySelectorAll('.hotspots-section').forEach(section => {
      if (!section.classList.contains('js-initialized')) {
        new HotspotSection(section);
        section.classList.add('js-initialized');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', initHotspotSections);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.hotspots-section');
    if (section) {
      section.classList.remove('js-initialized');
      new HotspotSection(section);
      section.classList.add('js-initialized');
    }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const blockId = block.dataset.shopifyBlockId || (block.closest('[data-hotspot-content]') ? block.closest('[data-hotspot-content]').dataset.hotspotContent : null);
    if (blockId) {
      const trigger = document.querySelector(`.hotspots-section [data-hotspot-trigger="${blockId}"]`);
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
        trigger.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredientes"]) return;
  try {
    
  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
  });
  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
  });

  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
    document.body.classList.add('menu-open'); // 🔥 activa la clase
  });

  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
    document.body.classList.remove('menu-open'); // 🔥 remueve la clase
  });


  function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');

  if (cartBubble) {
    // Si no existe el icono personalizado, lo agregamos
    if (!cartBubble.querySelector('#icon-cart')) {
      // Elimina el SVG original (si lo hubiera)
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();

      // Inserta el icono personalizado (solo beige)
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';

      cartBubble.prepend(img);
    }
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  // Detectar cambios en el DOM del header (Shopify lo recarga dinámicamente)
  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  // 1. LOGICA DE VISTAS (DASHBOARD <-> PEDIDOS)
  const viewDashboard = document.getElementById('view-dashboard');
  const viewOrders = document.getElementById('view-orders');
  const btnViewOrders = document.getElementById('btn-view-orders');
  const btnBackDashboard = document.getElementById('btn-back-dashboard');

  if(btnViewOrders && viewDashboard && viewOrders) {
    btnViewOrders.addEventListener('click', (e) => {
      e.preventDefault();
      viewDashboard.style.display = 'none';
      viewOrders.style.display = 'block';
    });
  }

  if(btnBackDashboard) {
    btnBackDashboard.addEventListener('click', (e) => {
      e.preventDefault();
      viewOrders.style.display = 'none';
      viewDashboard.style.display = 'block';
    });
  }

  // 2. LOGICA MENU & SCROLL
  const openBtn = document.getElementById('open-menu');
  const closeBtn = document.getElementById('close-menu');
  const menu = document.getElementById('mobile-menu');
  const header = document.querySelector('.header-banner');
  const logoImg = document.getElementById('header-logo-img');

  if(openBtn) openBtn.addEventListener('click', () => { menu.style.display = 'flex'; document.body.style.overflow = 'hidden'; });
  if(closeBtn) closeBtn.addEventListener('click', () => { menu.style.display = 'none'; document.body.style.overflow = ''; });

  function handleScroll() {
    if (window.scrollY > 10) {
      header.classList.add('scrolled');
      if(logoImg && logoImg.dataset.srcScrolled) logoImg.src = logoImg.dataset.srcScrolled;
    } else {
      header.classList.remove('scrolled');
      if(logoImg && logoImg.dataset.srcDefault) logoImg.src = logoImg.dataset.srcDefault;
    }
  }
  window.addEventListener('scroll', handleScroll);
  handleScroll();

  // 3. LOGICA CARRITO DRAWER
  const cartDrawer = document.getElementById('taw-cart-drawer');
  const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
  const closeCartBtn = document.getElementById('close-cart-drawer');
  const cartContainer = document.getElementById('cart-drawer-items');
  const countEl = document.getElementById('drawer-cart-count');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const bubble = document.getElementById('cart-count-number'); 

  function toggleDrawer(triggerId, drawerId, closeBtnId) {
    const trigger = document.getElementById(triggerId);
    const drawer = document.getElementById(drawerId);
    const closeBtn = document.getElementById(closeBtnId);
    if(!trigger || !drawer) return;

    const open = () => { 
      drawer.classList.add('active'); 
      document.body.style.overflow = 'hidden'; 
      fetchCart(); 
    };
    const close = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; };

    trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
    if(closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', (e) => { if(e.target === drawer) close(); });
  }

  // Activar Drawer Carrito
  toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

  function fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json()).then(cart => renderCart(cart));
  }

  function renderCart(cart) {
    if(countEl) countEl.innerText = cart.item_count;
    if(bubble) bubble.innerText = cart.item_count;
    if(subtotalEl) subtotalEl.innerText = '$' + (cart.total_price / 100).toFixed(0);
    
    cartContainer.innerHTML = '';
    if(cart.items.length === 0) {
      cartContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
      return;
    }

    cart.items.forEach(item => {
      cartContainer.innerHTML += `
        <div class="drawer-item">
          <div class="drawer-item-image"><a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a></div>
          <div class="drawer-item-details">
            <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
            <div class="qty-selector">
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
              <span>${item.quantity}</span>
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>`;
    });
  }

  window.changeQty = (key, qty) => {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(res => res.json()).then(cart => renderCart(cart));
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  
  // 1. HEADER & MENU LOGIC (COPIA EXACTA)
  const openBtn = document.getElementById('open-menu');
  const closeBtn = document.getElementById('close-menu');
  const menu = document.getElementById('mobile-menu');
  const header = document.querySelector('.header-banner');
  const logoImg = document.getElementById('header-logo-img');

  if(openBtn) openBtn.addEventListener('click', () => { menu.style.display = 'flex'; document.body.style.overflow = 'hidden'; });
  if(closeBtn) closeBtn.addEventListener('click', () => { menu.style.display = 'none'; document.body.style.overflow = ''; });

  function handleScroll() {
    if (window.scrollY > 10) {
      header.classList.add('scrolled');
      if(logoImg && logoImg.dataset.srcScrolled) logoImg.src = logoImg.dataset.srcScrolled;
    } else {
      header.classList.remove('scrolled');
      if(logoImg && logoImg.dataset.srcDefault) logoImg.src = logoImg.dataset.srcDefault;
    }
  }
  window.addEventListener('scroll', handleScroll);
  handleScroll();

  // 2. DRAWER CARRITO
  const cartDrawer = document.getElementById('taw-cart-drawer');
  const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
  const closeCartBtn = document.getElementById('close-cart-drawer');
  const cartContainer = document.getElementById('cart-drawer-items');
  const countEl = document.getElementById('drawer-cart-count');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const bubble = document.getElementById('cart-count-number');

  function toggleDrawer(triggerId, drawerId, closeBtnId) {
    const trigger = document.getElementById(triggerId);
    const drawer = document.getElementById(drawerId);
    const closeBtn = document.getElementById(closeBtnId);
    if(!trigger || !drawer) return;

    const open = () => { 
      drawer.classList.add('active'); 
      document.body.style.overflow = 'hidden'; 
      fetchCart(); 
    };
    const close = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; };

    trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
    if(closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('click', (e) => { if(e.target === drawer) close(); });
  }

  toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

  function fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json()).then(cart => renderCart(cart));
  }

  function renderCart(cart) {
    if(countEl) countEl.innerText = cart.item_count;
    if(bubble) bubble.innerText = cart.item_count;
    if(subtotalEl) subtotalEl.innerText = '$' + (cart.total_price / 100).toFixed(0);
    
    cartContainer.innerHTML = '';
    if(cart.items.length === 0) {
      cartContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
      return;
    }

    cart.items.forEach(item => {
      cartContainer.innerHTML += `
        <div class="drawer-item">
          <div class="drawer-item-image"><a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a></div>
          <div class="drawer-item-details">
            <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
            <div class="qty-selector">
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
              <span>${item.quantity}</span>
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>`;
    });
  }

  window.changeQty = (key, qty) => {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(res => res.json()).then(cart => renderCart(cart));
  };


  // 3. LOGICA DIRECCIONES (Mostrar/Ocultar Formularios)
  const addButton = document.querySelector('.btn-add-new');
  const addForm = document.getElementById('AddAddress');
  
  if(addButton && addForm) {
    addButton.addEventListener('click', () => {
      addForm.style.display = addForm.style.display === 'none' ? 'block' : 'none';
      if(addForm.style.display === 'block') addForm.scrollIntoView({behavior: 'smooth'});
    });
  }

  // Cancelar Agregar
  if(addForm) {
    const cancelAdd = addForm.querySelector('.btn-cancel');
    if(cancelAdd) {
      cancelAdd.addEventListener('click', (e) => {
        e.preventDefault();
        addForm.style.display = 'none';
      });
    }
  }

  // Editar Direcciones (Popup)
  const editButtons = document.querySelectorAll('.btn-edit');
  editButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const formId = btn.getAttribute('aria-controls');
      const form = document.getElementById(formId);
      if(form) {
        form.style.display = 'block';
        
        // Crear overlay oscuro
        const overlay = document.createElement('div');
        overlay.className = 'taw-drawer-overlay active';
        overlay.style.zIndex = '10001'; // Debajo del form (10002)
        document.body.appendChild(overlay);
        
        const closeForm = () => {
          form.style.display = 'none';
          overlay.remove();
        };

        overlay.addEventListener('click', closeForm);
        
        const cancelBtn = form.querySelector('.btn-cancel');
        if(cancelBtn) cancelBtn.addEventListener('click', (e) => { e.preventDefault(); closeForm(); });
      }
    });
  });

  // Eliminar Direcciones
  const deleteButtons = document.querySelectorAll('.btn-delete');
  deleteButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      if(confirm(btn.getAttribute('data-confirm-message'))) {
        const targetUrl = btn.getAttribute('data-target');
        const form = document.createElement('form');
        form.method = 'post';
        form.action = targetUrl;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = '_method';
        input.value = 'delete';
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
      }
    });
  });

  // Inicializar selectores de país/provincia
  if (typeof CustomerAddresses !== 'undefined') {
    new CustomerAddresses();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    


  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
  });
  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
  });

  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
    document.body.classList.add('menu-open'); // 🔥 activa la clase
  });

  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
    document.body.classList.remove('menu-open'); // 🔥 remueve la clase
  });


  function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');

  if (cartBubble) {
    // Si no existe el icono personalizado, lo agregamos
    if (!cartBubble.querySelector('#icon-cart')) {
      // Elimina el SVG original (si lo hubiera)
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();

      // Inserta el icono personalizado (solo beige)
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';

      cartBubble.prepend(img);
    }
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  // Detectar cambios en el DOM del header (Shopify lo recarga dinámicamente)
  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const openMenuBtn = document.getElementById('open-menu');
  const closeMenuBtn = document.getElementById('close-menu');
  const mobileMenu = document.getElementById('mobile-menu');
  const headerBanner = document.querySelector('.hero-ingredientes-banner .header-banner');

  openMenuBtn.addEventListener('click', () => {
    mobileMenu.style.display = 'flex';
    document.body.classList.add('menu-open');
  });

  closeMenuBtn.addEventListener('click', () => {
    mobileMenu.style.display = 'none';
    document.body.classList.remove('menu-open');
  });

  function handleHeaderScroll() {
    if (window.scrollY > 10) {
      headerBanner.classList.add('scrolled');
    } else {
      headerBanner.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', handleHeaderScroll);
  document.addEventListener('DOMContentLoaded', handleHeaderScroll);

  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
  });
  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
  });

  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
    document.body.classList.add('menu-open'); // 🔥 activa la clase
  });

  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
    document.body.classList.remove('menu-open'); // 🔥 remueve la clase
  });


  function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');

  if (cartBubble) {
    // Si no existe el icono personalizado, lo agregamos
    if (!cartBubble.querySelector('#icon-cart')) {
      // Elimina el SVG original (si lo hubiera)
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();

      // Inserta el icono personalizado (solo beige)
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';

      cartBubble.prepend(img);
    }
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  // Detectar cambios en el DOM del header (Shopify lo recarga dinámicamente)
  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
  });
  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
  });

  document.getElementById('open-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'flex';
    document.body.classList.add('menu-open'); // 🔥 activa la clase
  });

  document.getElementById('close-menu').addEventListener('click', function () {
    document.getElementById('mobile-menu').style.display = 'none';
    document.body.classList.remove('menu-open'); // 🔥 remueve la clase
  });


  function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');

  if (cartBubble) {
    // Si no existe el icono personalizado, lo agregamos
    if (!cartBubble.querySelector('#icon-cart')) {
      // Elimina el SVG original (si lo hubiera)
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();

      // Inserta el icono personalizado (solo beige)
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';

      cartBubble.prepend(img);
    }
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  // Detectar cambios en el DOM del header (Shopify lo recarga dinámicamente)
  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-universal"] && !Shopify.designMode) return;
  try {
    
document.getElementById('open-menu').addEventListener('click', function () {
  document.getElementById('mobile-menu').style.display = 'flex';
  document.body.classList.add('menu-open');
});

document.getElementById('close-menu').addEventListener('click', function () {
  document.getElementById('mobile-menu').style.display = 'none';
  document.body.classList.remove('menu-open');
});

function updateCustomCartIcon() {
  const cartBubble = document.querySelector('#cart-icon-bubble');
  if (cartBubble) {
    if (!cartBubble.querySelector('#icon-cart')) {
      const svgWrapper = cartBubble.querySelector('.svg-wrapper');
      if (svgWrapper) svgWrapper.remove();
      const img = document.createElement('img');
      img.id = 'icon-cart';
      img.alt = 'Carrito';
      img.src = 'https://cdn.shopify.com/s/files/1/0949/8198/0473/files/carrito-beige.png?v=1760386221';
      img.style.transition = 'opacity 0.3s ease';
      cartBubble.prepend(img);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateCustomCartIcon();

  const headerObserver = new MutationObserver(() => {
    updateCustomCartIcon();
  });

  headerObserver.observe(document.body, { childList: true, subtree: true });
});

const headerUniversal = document.querySelector('.menu-universal .menu-header');

function handleHeaderScroll() {
  if (window.scrollY > 50) {
    headerUniversal.classList.add('scrolled');
  } else {
    headerUniversal.classList.remove('scrolled');
  }
}

window.addEventListener('scroll', handleHeaderScroll);
document.addEventListener('DOMContentLoaded', handleHeaderScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rituals"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // 1. MENU MOBILE
    const openMenuBtn = document.getElementById('open-menu');
    const closeMenuBtn = document.getElementById('close-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    if(openMenuBtn) {
      openMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'flex';
        document.body.classList.add('menu-open');
      });
    }
    if(closeMenuBtn) {
      closeMenuBtn.addEventListener('click', () => {
        mobileMenu.style.display = 'none';
        document.body.classList.remove('menu-open');
      });
    }

    // 2. SCROLL HEADER
    const headerBanner = document.querySelector('.header-banner');
    function handleScroll() {
      if (window.scrollY > 10) headerBanner.classList.add('scrolled');
      else headerBanner.classList.remove('scrolled');
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();

    // 3. DRAWERS
    function toggleDrawer(triggerId, drawerId, closeBtnId) {
      const trigger = document.getElementById(triggerId);
      const drawer = document.getElementById(drawerId);
      const closeBtn = document.getElementById(closeBtnId);
      if(!trigger || !drawer) return;
      const openDrawer = () => { drawer.classList.add('active'); document.body.style.overflow = 'hidden'; };
      const closeDrawer = () => { drawer.classList.remove('active'); document.body.style.overflow = ''; };
      trigger.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
      if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
      drawer.addEventListener('click', (e) => { if (e.target === drawer) closeDrawer(); });
    }
    toggleDrawer('login-drawer-trigger', 'taw-login-drawer', 'close-login-drawer');
    toggleDrawer('cart-icon-bubble-trigger', 'taw-cart-drawer', 'close-cart-drawer');

    // 4. CARRITO AJAX
    const cartTrigger = document.getElementById('cart-icon-bubble-trigger');
    const cartItemsContainer = document.getElementById('cart-drawer-items');
    const cartCountEl = document.getElementById('drawer-cart-count');
    const cartSubtotalEl = document.getElementById('cart-drawer-subtotal');
    const cartBubbleNumber = document.getElementById('cart-count-number');
    if(cartTrigger) cartTrigger.addEventListener('click', () => fetchCart());
    function formatMoney(cents) { return '$' + (cents / 100).toFixed(0); }
    function fetchCart() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json()).then(cart => { renderCart(cart); updateCartCount(cart.item_count); }).catch(err => console.error(err));
    }
    function renderCart(cart) {
      if(cartCountEl) cartCountEl.innerText = cart.item_count;
      if(cartSubtotalEl) cartSubtotalEl.innerText = formatMoney(cart.total_price);
      cartItemsContainer.innerHTML = '';
      if (cart.items.length === 0) {
        cartItemsContainer.innerHTML = '<p style="text-align:center; margin-top:40px;">Tu carrito está vacío.</p>';
        return;
      }
      cart.items.forEach(item => {
        cartItemsContainer.innerHTML += `
          <div class="drawer-item">
            <div class="drawer-item-image">
               <a href="${item.url}"><img src="${item.image || ''}" alt="${item.title}"></a>
            </div>
            <div class="drawer-item-details">
              <div class="drawer-item-text">
                <a href="${item.url}" class="drawer-item-title">${item.product_title}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
              </div>
              <div class="qty-selector">
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">-</button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>
        `;
      });
    }
    window.changeQty = function(key, newQty) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: newQty })
      }).then(res => res.json()).then(cart => { renderCart(cart); updateCartCount(cart.item_count); });
    };
    function updateCartCount(count) {
      if(cartBubbleNumber) cartBubbleNumber.innerText = count;
      if(cartCountEl) cartCountEl.innerText = count;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upper-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const banner = document.querySelector('.countdown-banner-wrapper[data-section-id="{{ section.id }}"]');
    if (!banner) return;

    const endDateString = banner.dataset.endDate;
    const countdownElement = banner.querySelector('#countdown-timer-{{ section.id }}');

    if (!endDateString || !countdownElement) {
      if(countdownElement) countdownElement.style.display = 'none';
      return;
    }

    // Usamos el formato que no cause problemas entre navegadores (reemplazamos '-' con '/')
    const targetDate = new Date(endDateString.replace(/-/g, "/")).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        banner.style.display = 'none'; // Oculta toda la barra cuando el tiempo termina
        clearInterval(timerInterval);
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownElement.innerHTML = `${hours}h ${minutes}min ${seconds}seg`;
    };

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer(); // Llama a la función una vez al cargar para evitar el retraso de 1 segundo
  })();

  } catch(e) { console.error(e); }
})();
})();
